import { connect } from 'react-redux';
import _get from 'lodash/get';

import { updateZoomEvent, fetchSuggestedAttireOptions } from 'actions/EventActions';
import { showModal } from 'actions/ModalActions';
import { getEventByHash } from 'actions/website/entities/EventActions';

import { getCurrentZoomEvent } from 'selectors/events/eventsSelectors';

import ZoomEdit from './ZoomEdit';

const mapStateToProps = (state, ownProps) => ({
  zoomEvent: getCurrentZoomEvent(state),
  eventHash: _get(ownProps, 'params.eventHash'),
});

const mapDispatchToProps = dispatch => {
  return {
    onFetchEventByHash: eventHash => dispatch(getEventByHash(eventHash)),
    onFetchSuggestAttire: () => dispatch(fetchSuggestedAttireOptions()),
    openSuggestionModal: addSuggestion =>
      dispatch(
        showModal(
          'GUEST_MANAGER_SUGGESTION_MODAL',
          { variant: 'attire', addSuggestion },
          { size: 'md' }
        )
      ),
    updateZoomEvent: (values, customMsg) => dispatch(updateZoomEvent(values, customMsg)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoomEdit);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEdit/index.js